const isAbsolute = process.env.REACT_APP_API_BASE && /^https?:\/\//.test(process.env.REACT_APP_API_BASE);
export const API_BASE = process.env.REACT_APP_API_BASE || '/api';
export const WS_URL   = isAbsolute
  ? process.env.REACT_APP_API_BASE.replace(/^http/, 'ws').replace(/\/api$/, '') + '/ws'
  : (typeof window !== 'undefined'
      ? `${window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${window.location.host}/ws`
      : '');

const TOKEN_KEY = 'pau_token';

export const tokenStore = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

async function request(path, { method = 'GET', body, auth = true } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (auth) {
    const token = tokenStore.get();
    if (token) headers.Authorization = `Bearer ${token}`;
  }
  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const text = await res.text();
  const data = text ? JSON.parse(text) : null;
  if (!res.ok) {
    const err = new Error(data?.error || `HTTP ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return data;
}

export const api = {
  // Auth
  bootstrap:  ()                     => request('/auth/bootstrap', { auth: false }),
  login:      (username, password)   => request('/auth/login',     { method: 'POST', body: { username, password }, auth: false }),
  register:   (username, password)   => request('/auth/register',  { method: 'POST', body: { username, password }, auth: false }),
  me:         ()                     => request('/auth/me'),

  // Users (admin)
  listUsers:   ()                          => request('/users'),
  createUser:  (username, password, role)  => request('/users',          { method: 'POST',   body: { username, password, role } }),
  updateRole:  (id, role)                  => request(`/users/${id}`,    { method: 'PATCH',  body: { role } }),
  deleteUser:  (id)                        => request(`/users/${id}`,    { method: 'DELETE' }),

  // Vehicles
  listVehicles:  ()                                  => request('/vehicles'),
  createVehicle: (id, name, plate, speed_limit_kmh)  => request('/vehicles',       { method: 'POST',   body: { id, name, plate, speed_limit_kmh } }),
  updateVehicle: (id, name, plate, speed_limit_kmh)  => request(`/vehicles/${id}`, { method: 'PUT',    body: { name, plate, speed_limit_kmh } }),
  deleteVehicle: (id)                                => request(`/vehicles/${id}`, { method: 'DELETE' }),

  // Geofences
  listGeofences:   ()                              => request('/geofences'),
  createGeofence:  (data)                          => request('/geofences',       { method: 'POST',   body: data }),
  updateGeofence:  (id, data)                      => request(`/geofences/${id}`, { method: 'PUT',    body: data }),
  deleteGeofence:  (id)                            => request(`/geofences/${id}`, { method: 'DELETE' }),

  // Alerts
  listAlerts:      (limit = 100, vehicleId)        => request(`/alerts?limit=${limit}${vehicleId ? `&vehicle_id=${vehicleId}` : ''}`),
  deleteAlert:     (id)                            => request(`/alerts/${id}`, { method: 'DELETE' }),
  clearAlerts:     ()                              => request(`/alerts`,       { method: 'DELETE' }),

  // Locations
  history: (vehicleId, start, end)        => request(`/location/${vehicleId}/history?start=${start}&end=${end}`),
  stats:   (vehicleId, start, end)        => request(`/location/${vehicleId}/stats?start=${start}&end=${end}`),
  days:    (vehicleId)                    => request(`/location/${vehicleId}/days`),

  // Device console (admin)
  deviceLogs:        (vehicleId, limit = 200) => request(`/device/${vehicleId}/logs?limit=${limit}`),
  clearDeviceLogs:   (vehicleId)              => request(`/device/${vehicleId}/logs`, { method: 'DELETE' }),
  deviceCommands:    (vehicleId)              => request(`/device/${vehicleId}/commands`),
  deviceCommand:     (vehicleId, cmd, payload) => request(`/device/${vehicleId}/command`, { method: 'POST', body: { cmd, payload } }),

  // Demo mode (admin)
  demoStatus: ()                               => request('/demo/status'),
  demoStart:  (vehicle_id, seed_minutes = 30)  => request('/demo/start', { method: 'POST', body: { vehicle_id, seed_minutes } }),
  demoStop:   ()                               => request('/demo/stop',  { method: 'POST' }),
};
